import React, { useCallback } from 'react';
import { Tag } from '@moda/om';
import classNames from 'classnames';
import { usePLPParams } from '../../hooks/usePLPParams';
import { ProductListPageResultFragment_saleTags as SaleTags } from '../../generated/types/ProductListPageResultFragment';
import { getSaleTagItems } from './getSaleTagItems';

import './SalePercentageTags.scss';

interface SalePercentageTagsProps {
  saleTags: (SaleTags | null)[];
}

export const SalePercentageTags: React.FC<SalePercentageTagsProps> = ({ saleTags }) => {
  const { params, addFilterList, removeFilterList, clearFilter } = usePLPParams();

  const handleClick = useCallback(
    (selectedValue, isSelected) => {
      selectedValue.length === 0
        ? clearFilter('saletags')
        : isSelected
        ? removeFilterList('saletags', selectedValue)
        : addFilterList('saletags', selectedValue);
    },
    [addFilterList, removeFilterList, clearFilter]
  );

  if (params.section !== 'sale' || !saleTags) {
    return null;
  }

  const saleFilters = getSaleTagItems(saleTags, params['saletags']);

  return (
    <div className="SalePercentageTags" data-testid="SalePercentageTags">
      {saleFilters?.map(filter => (
        <Tag
          key={filter.key}
          className={classNames('SalePercentageTags__badge', {
            'SalePercentageTags__badge--active': filter.isSelected
          })}
          onClick={() => handleClick(filter.value, filter.isSelected)}
          data-testid={`SalePercentageTags__badge-${filter.label.replace(' ', '')}`}
        >
          {filter.label}
        </Tag>
      ))}
    </div>
  );
};
